/* Charliee cart
 *
 * The cart page repaints itself from the /cart/update.js JSON response.
 *
 * It used to rely on a second request to the Section Rendering API to redraw
 * the totals and the delivery meter. That is a whole extra round-trip after
 * the one that already returned everything we need - and if it failed for any
 * reason, the numbers silently stopped moving while the stepper kept working.
 *
 * Now: tap -> number changes instantly -> one batched /cart/update.js -> every
 * figure on the page is repainted from that response. The section re-render is
 * kept only for the upsell PRODUCT CARDS, whose contents depend on Liquid.
 * The upsell heading is repainted here too, so the shortfall never lags.
 */
(function () {
  'use strict';

  var DEBOUNCE = 400;

  var pending = {};
  var timer = null;
  var gen = 0;

  var root = document.querySelector('cart-items.cab-cart');
  if (!root) return;

  /* GST-exempt variant ids, rendered by charlie-cart.liquid from the exempt
   * collection. Kept as strings so the comparison against cart JSON is exact. */
  var GST_EXEMPT = (root.dataset.cabGstExemptIds || '')
    .split(',')
    .map(function (v) { return v.trim(); })
    .filter(Boolean);

  /* ---------- money ---------- */
  function money(paise, dropZeros) {
    var n = paise / 100;
    var opts = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    if (dropZeros && n % 1 === 0) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
    return '\u20B9' + n.toLocaleString('en-IN', opts);
  }

  function has(o) { for (var k in o) { if (o.hasOwnProperty(k)) return true; } return false; }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  /* ---------- upsell heading ----------
   * Lives in charlie-upsell.liquid. Repainted from the cart JSON so the
   * shortfall tracks the stepper immediately, rather than waiting for the
   * section render that refreshes the product cards. */
  function paintUpsellHead(total) {
    var head = $('[data-cab-up-head]');
    if (!head) return;

    var goal = parseInt(head.getAttribute('data-cab-up-goal'), 10) || 0;
    var short = goal - total;
    var near = goal > 0 && short > 0;

    var t = $('[data-cab-up-t]', head);
    var n = $('[data-cab-up-n]', head);

    if (t) {
      t.innerHTML = near
        ? 'Add <b data-cab-up-amt style="color:#E30016">' + money(short, true) + '</b> more to unlock free delivery'
        : (head.getAttribute('data-cab-up-head-far') || '');
    }
    if (n) {
      n.innerHTML = near
        ? (head.getAttribute('data-cab-up-note-near') || '')
        : (head.getAttribute('data-cab-up-note-far') || '');
    }
  }

  /* ---------- repaint from cart JSON ---------- */
  function paint(cart) {
    // line rows
    var seen = {};
    (cart.items || []).forEach(function (item) {
      var id = String(item.variant_id);
      seen[id] = true;
      var row = $('[data-cab-line="' + id + '"]');
      if (!row) return;
      var price = $('[data-cab-line-price]', row);
      if (price) {
        price.innerHTML = item.original_line_price !== item.final_line_price
          ? '<s>' + money(item.original_line_price) + '</s>' + money(item.final_line_price)
          : money(item.original_line_price);
      }
      var input = $('input', row);
      if (input && !has(pending)) input.value = item.quantity;
      row.hidden = false;
    });

    // rows no longer in the cart
    document.querySelectorAll('[data-cab-line]').forEach(function (row) {
      if (!seen[row.getAttribute('data-cab-line')]) row.remove();
    });

    // count
    var count = $('[data-cab-count]');
    if (count) count.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');

    // totals
    var sub = $('[data-cab-subtotal]');
    if (sub) sub.textContent = money(cart.items_subtotal_price);

    var total = $('[data-cab-total]');
    if (total) total.textContent = money(cart.total_price);

    var coAmt = $('[data-cab-co-amount]');
    if (coAmt) coAmt.textContent = money(cart.total_price);

    // discount
    var original = 0;
    (cart.items || []).forEach(function (i) { original += i.original_line_price; });
    var saved = original - cart.total_price;
    var dRow = $('[data-cab-discount-row]');
    if (dRow) {
      dRow.hidden = saved <= 0;
      var d = $('[data-cab-discount]', dRow);
      if (d && saved > 0) d.textContent = '\u2212' + money(saved);
    }

    /* GST - display only, backed OUT of the MRP so the total never moves.
     * Mirrors the Liquid in charlie-cart.liquid exactly, including the
     * exemption, so the figure does not jump between page load and repaint. */
    var gstRow = $('[data-cab-gst-row]');
    if (gstRow) {
      var rate = parseInt(root.dataset.cabGstRate, 10) || 0;
      var gst = 0;
      if (rate > 0) {
        (cart.items || []).forEach(function (i) {
          if (GST_EXEMPT.indexOf(String(i.variant_id)) !== -1) return;
          gst += Math.round(i.final_line_price * rate / (100 + rate));
        });
      }
      gstRow.hidden = gst <= 0;
      var g = $('[data-cab-gst]', gstRow);
      if (g) g.textContent = money(gst);
    }

    // delivery meter
    var ship = $('[data-cab-ship]');
    var freeNow = false;
    if (ship) {
      var goal = parseInt(ship.getAttribute('data-cab-threshold'), 10) || 0;
      var left = goal - cart.total_price;
      freeNow = left <= 0;

      var filled = goal > 0 ? Math.min(100, Math.max(0, Math.round(cart.total_price * 100 / goal))) : 0;
      var truckPos = Math.min(84, Math.max(4, filled));

      var bar = $('[data-cab-ship-bar]', ship);
      if (bar) {
        bar.setAttribute('width', filled);
        bar.setAttribute('fill', freeNow ? '#0E9F6E' : '#E30016');
      }

      var truck = $('[data-cab-ship-truck]', ship);
      if (truck) {
        truck.style.left = truckPos + '%';
        truck.style.display = freeNow ? 'none' : 'flex';
      }

      var amt = $('[data-cab-ship-amt]', ship);
      var cap = $('[data-cab-ship-cap]', ship);
      var sub2 = $('[data-cab-ship-sub]', ship);
      if (amt) {
        amt.textContent = freeNow ? 'Unlocked' : money(left, true);
        amt.style.color = freeNow ? '#0E9F6E' : '#E30016';
      }
      if (cap) cap.textContent = freeNow ? 'delivery is on us' : 'away from free delivery';
      if (sub2 && freeNow) sub2.textContent = 'Free delivery applied to this order.';
      if (sub2 && !freeNow) sub2.textContent = 'Free delivery on orders over ' + money(goal, true);

      ship.classList.toggle('is-done', freeNow);
      ship.style.background = freeNow
        ? 'linear-gradient(135deg,#EDFAF3 0%,#F5F9FC 100%)'
        : 'linear-gradient(135deg,#FFF5F6 0%,#F8F9FD 100%)';
      ship.style.borderColor = freeNow ? 'rgba(14,159,110,.3)' : 'rgba(227,0,22,.18)';

      var goalDot = $('[data-cab-ship-goal]', ship);
      if (goalDot) {
        goalDot.style.background = freeNow ? '#0E9F6E' : '#fff';
        goalDot.style.color = freeNow ? '#fff' : '#8E939B';
        goalDot.style.border = freeNow ? '1.5px solid #0E9F6E' : '1.5px dashed rgba(20,22,27,.2)';
      }
    }

    // upsell heading - instant, no section render needed
    paintUpsellHead(cart.total_price);

    // delivery row
    var delRow = $('[data-cab-delivery-row]');
    if (delRow) {
      delRow.classList.toggle('cab-tot__row--free', freeNow);
      var del = $('[data-cab-delivery]', delRow);
      if (del) del.textContent = freeNow ? 'Free' : 'At checkout';
    }

    // savings strip
    var strip = $('[data-cab-save-strip]');
    if (strip) {
      var txt = $('[data-cab-save-text]', strip);
      if (saved > 0) {
        strip.hidden = false;
        if (txt) txt.textContent = 'You save ' + money(saved) + ' on this order';
      } else if (freeNow) {
        strip.hidden = false;
        if (txt) txt.textContent = 'Free delivery applied to this order';
      } else {
        strip.hidden = true;
      }
    }

    // header bubble
    var bubble = document.querySelector('.cart-count-bubble span, .cart-count-bubble');
    if (bubble) bubble.textContent = cart.item_count;

    if (cart.item_count === 0) window.location.reload();
  }

  /* upsell CARDS depend on Liquid, so they still need a section render */
  function refreshUpsell() {
    var host = document.getElementById('main-cart-items');
    var id = host && host.dataset.id;
    if (!id) return;
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data[id] || has(pending)) return;
        var doc = new DOMParser().parseFromString(data[id], 'text/html');
        var fresh = doc.querySelector('.cab-upsell-inner');
        var slot = document.querySelector('#cab-upsell-wrap .cab-upsell-inner');
        if (fresh && slot) slot.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- send ---------- */
  function flush() {
    if (!has(pending)) return;
    var updates = pending;
    pending = {};
    var mine = ++gen;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (mine !== gen) return;
        paint(cart);
        refreshUpsell();
      })
      .catch(function () {
        var box = document.getElementById('cart-errors');
        if (box) box.textContent = 'Could not update the bag. Please try again.';
      });
  }

  function schedule(variantId, qty) {
    pending[variantId] = qty;
    clearTimeout(timer);
    timer = setTimeout(flush, DEBOUNCE);
  }

  /* ---------- stepper ---------- */
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var btn = event.target.closest('.cab-qty button[name]');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    var wrap = btn.closest('.cab-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;

    var variantId = input.getAttribute('data-quantity-variant-id');
    if (!variantId) return;

    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var current = parseInt(input.value, 10) || 0;
    var next = btn.name === 'plus' ? current + step : current - step;
    if (next < 0) next = 0;
    if (next === current) return;

    input.value = next;

    var row = btn.closest('.cab-line');
    if (row) row.style.opacity = next === 0 ? '.45' : '';

    schedule(variantId, next);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('.cab-qty input')) return;
    var variantId = input.getAttribute('data-quantity-variant-id');
    if (!variantId) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    input.value = qty;
    schedule(variantId, qty);
  });

  /* checkout must not race a queued update */
  document.addEventListener('click', function (event) {
    var co = event.target.closest && event.target.closest('.cab-co');
    if (!co || !has(pending)) return;
    event.preventDefault();
    clearTimeout(timer);
    var updates = pending;
    pending = {};
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      var form = document.getElementById('cart');
      if (form) form.submit();
    });
  });

  window.addEventListener('pagehide', function () {
    if (!has(pending)) return;
    var body = JSON.stringify({ updates: pending });
    pending = {};
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/cart/update.js', new Blob([body], { type: 'application/json' }));
    }
  });

  /* ---------- quick-add from the upsell rail ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-cab-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var variantId = Number(btn.getAttribute('data-cab-add'));
    if (!variantId) return;

    var label = btn.querySelector('[data-cab-add-label]') || btn;
    var original = label.textContent;
    btn.disabled = true;
    label.textContent = 'Adding';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (b) {
          if (!r.ok) throw new Error(b.description || b.message || 'Could not add');
          return b;
        });
      })
      .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.location.reload();
      })
      .catch(function (err) {
        label.textContent = original;
        btn.disabled = false;
        var box = document.getElementById('cart-errors');
        if (box) box.textContent = err.message || 'Sorry, that could not be added.';
      });
  });
})();
